import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnPolicyConfigurationSkeleton = () => {
  return (
    <Styles.MainContainer>
      <Skeleton variant="text" width="100%" height={20} />

      <Skeleton variant="text" width={240} height={28} />

      <Styles.Section>
        <Skeleton variant="text" width={200} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={200} height={20} />
        </Styles.ToggleRow>
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={200} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={240} height={20} />
        </Styles.ToggleRow>
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={180} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={220} height={20} />
        </Styles.ToggleRow>
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={220} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={200} height={20} />
        </Styles.ToggleRow>
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={180} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={220} height={20} />
        </Styles.ToggleRow>
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={200} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={200} height={20} />
        </Styles.ToggleRow>
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={200} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={220} height={20} />
        </Styles.ToggleRow>
      </Styles.Section>
    </Styles.MainContainer>
  )
}

export default ReturnPolicyConfigurationSkeleton
